<template>
  <div id="daystepper">
    <div class="stepDown" @click="stepDown" :class="{active: firstItem}">
      &lt;
</div>
    <div class="dayOfMonth">{{ date }}</div>
    <div class="stepUp" @click="stepUp"  :class="{active:lastItem}">&gt;
</div>
  </div>
</template>
<style scoped>
#daystepper {
  display: flex;
  justify-content: center;
  width: 100%;
  -webkit-user-select: none; /* Chrome all / Safari all */
  -moz-user-select: none;   /* Firefox all */
  -ms-user-select: none;  /* IE 10+ */
   user-select: none;  /* Likely future */
}
.stepDown {
  background: url("../assets/stepdown.svg");
  width: 91px;
font-family: "BornReady";
  font-size: 60px;
  line-height: 60px;
  text-align: right;
  color: #F0EEEA;
  padding-right: 20px;
  opacity: 0.6;
}
.stepUp {
  width: 91px;
  background: url("../assets/stepup.svg");
  font-family: "BornReady";
  font-size: 60px;
  line-height: 60px;
  text-align: left;
  padding-left:20px;
color: #F0EEEA;
opacity: 0.6;
}
.active {
  opacity:1;
  cursor: pointer;
}
.dayOfMonth {
  font-family: "BornReady";
  font-size: 32px;
line-height: 60px;
text-align: center;
font-weight: 100;
background: #F0EEEA;
height: 60px;
padding: 0 10px;
}

@media (min-width: 768px) {
  #daystepper {
 right: 94px;
  justify-content: flex-end;
  width: auto;
}
}
</style>

<script>
/**
  De tool rechts onder om door de dagen van de maand te lopen
*/
function daysAfter(count) {
  const startDate = new Date(Date.UTC(1944, 5, 1))
  let millisecondsAfter = (count )* 24 * 60 * 60 * 1000;
  return  new Date(startDate.getTime() + millisecondsAfter)
}
export default {
  name: "DayStepper",
  computed: {
    date() {
      let d=  daysAfter(this.day)
      return d.getDate() + ' ' + this.month.naam+ ' ' +d.getFullYear()
    },
    day() {
      return this.$store.state.map.counterDay
    },
    month() {
      return  this.$store.state.config.months.filter(d=>d.naam === this.$route.params.month)[0]
    },
    firstItem() {
      return daysAfter(this.day).getDate()===1?false:true
    },
    lastItem() {
      return daysAfter(this.day).getDate()<this.month.dagen?true:false
    }
  },
  methods:{
    stepDown: function() {
      if(this.firstItem)  this.$store.commit('map/setCounter',this.day -1 )
    },
    stepUp: function() {

      if(this.lastItem) this.$store.commit('map/setCounter',this.day +1 )
    }
  }

};
</script>
